import { render, staticRenderFns } from "./BanEditProfile.vue?vue&type=template&id=67aae944&scoped=true&"
import script from "./BanEditProfile.vue?vue&type=script&lang=js&"
export * from "./BanEditProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67aae944",
  null
  
)

export default component.exports